// import Homenav from "./homenav";
// import HomeSideNav from "./homesidenav";

import React, {useEffect, useState} from "react";
import SideBarMenu from "./SideBarMenu";
import LoginPopUp from "../common/alert/login/LoginPopUp";
import {useLocation, useNavigate} from "react-router-dom";

export default function HomeSidebarMenuList() {
    const navigate = useNavigate();
    const location = useLocation();
    const [userLocalData, setUserLocalData] = useState(undefined);
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        setUserLocalData(userData);
    }, []);
    const handleModalClose = () => {
        // Close the modal and reset the URL to the current page
        setLoginModalOpen(false);
        navigate(location.pathname, {replace: true});
    };
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);

    return (
        <div>
            {/* {userLocalData && <Homenav />}
            {!userLocalData && <HomeSideNav />} */}
            {isLoginModalOpen && (
                <LoginPopUp
                    isLoginModalOpen={isLoginModalOpen}
                    setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                    onClose={handleModalClose}
                />
            )}
            <SideBarMenu setLoginModalOpen={setLoginModalOpen} />
        </div>
    );
}
